<template>
  <div class="searchfield">
    <label for="keyword" v-if="displayLabel">Fritext</label>
    <div>
      <input
        :type="type"
        name="keyword"
        v-model="value__"
        @keyup.enter="change()"
        @input="requireEnterToSearch ? null : change()"
        :placeholder="this.placeholder"
        :class="this.placeButtonStart ? 'start' : ''"
        :autocomplete="autoComplete ? 'on' : 'off'"
      />
      <IconLoader v-if="!!showLoader" class="loaderposition"/>
      <button type="submit" @click="change()" class="button" :class="this.placeButtonStart ? 'start' : ''">
        <span class="sr-only">Sök</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import IconLoader from '@/components/icons/IconLoader';
export default {
  components: { IconLoader },
  props: {
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Sök på adress eller område',
    },
    placeButtonStart: {
      type: Boolean,
      default: false,
    },
    requireEnterToSearch: {
      type: Boolean,
      default: true,
    },
    displayLabel: {
      type: Boolean,
      default: true,
    },
    autoComplete: {
      type: Boolean,
      default: true,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      /**
       * Inskickat prop får inte manipuleras. Därför klonas den (eller va gör data() med den?)
       */
      value__: this.value,
    };
  },
  computed: {},
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     */
    value: {
      handler() {
        this.value__ = this.value;
      },
    },
  },
  methods: {
    change() {
      console.log("CHANGE")
      this.$emit('update:modelValue', this.value__);
    },
  },
};
</script>


<style lang="scss" scoped>
.searchfield {

  & > div {
    display: flex;
    position: relative;
  }

  label {
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 0.42px;
    font-weight: 600;
    display: block;
  }

  .multiselect {
    width: 136px;
  }

  .loaderposition {
    position: absolute;
    right: 32px;
    top: 18px;
  }
  input {
    box-shadow: unset !important;
    position: relative;
    border: 1px solid $darkgray;
    border-radius: 5px !important;
    margin-bottom: 25px;
    width: 100%;
    padding: 10px 40px 10px 10px;
    margin-top: 8px;
  }

  input::placeholder {
    color: rgba(94, 94, 94, var(--tw-text-opacity, 1));
  }

  input.start {
    padding: 10px 10px 10px 40px;
  }

  input:focus {
    box-shadow: unset !important;
    border: 1px solid $abgdarkblue;
  }

  .button {
    border: none;
    outline: none;
    width: 20px;
    height: 20px;
    background: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-search.svg);
    background-size: contain;
    position: absolute;
    top: 20px;
    right: 14px;
  }
  .button.start {
    left: 14px;
    right: unset;
  }
}

</style>
